export const ROLE = {
  ADMIN: 'ROLE_ADMIN',
  COMMERCIAL: 'ROLE_COMMERCIAL',
  CONSULTANT: 'ROLE_CONSULTANT',
  DIRECTION: 'ROLE_DIRECTION',
  DELIVERY_MANAGER: 'ROLE_DELIVERY_MANAGER',
  TALENT_MANAGER: 'ROLE_TALENT_MANAGER',
  MANAGER: 'ROLE_MANAGER',
  ACQUISITION_MANAGER: 'ROLE_TALENT_ACQUISITION_MANAGER',
  TESTEUR: 'ROLE_TESTEUR'
};
